<template>
  <div class="contain_menu">
    <span class="font_16_000000_85">基本信息</span>
    <el-form label-position="top" label-width="80px" style="width: 600px; margin-top: 29px">
      <el-form-item label="角色名称" required>
        <el-input v-model="roleName" placeholder="请输入角色名称"> </el-input>
      </el-form-item>
      <el-form-item label="描述:">
        <el-input type="textarea" placeholder="请输入角色描述" v-model="roleDes"></el-input>
      </el-form-item>
    </el-form>
    <div class="flex_row_center" style="margin-top: 36px">
      <span class="font_16_000000_85">权限配置</span>
      <img class="image_1" src="../../../../assets/img/xiangmupeizhi.png" alt="" />
    </div>
    <div class="font_14_000000_45" style="margin-top: 4px; margin-bottom: 14px">
      如果当前角色需要进行二次授权时，当前角色权限配置的内容将作为该角色二次授权的权限范围。
    </div>
    <div class="segment_contain">
      <div
        class="segment_left_contain"
        :class="{ segment_select_color: systermIsSelect }"
        @click="leftClicked"
      >
        系统管理权限
      </div>
      <div
        class="segment_right_contain"
        :class="{ segment_select_color: applicationIsSelect }"
        @click="rightClicked"
      >
        应用权限
      </div>
    </div>
    <div class="bottom_contain">
      <div class="bottom_left_contain">
        <systermAuthMenuTemplate
          v-show="systermIsSelect"
          @systermAuthorMenuClicked="systemAuthorMenthodClickedMenthod"
        />
        <applicationAuthMenuTemplate
          v-show="applicationIsSelect"
          @applicationAuthorMenuClicked="applicationAuthorMenuClickedMenthod"
        />
      </div>
      <div class="bottom_right_contain">
        <systermAuthorOne
          v-show="selectSystemAuthorIndex === 0 && systermIsSelect"
          @systermAuthorOneMenthod="systermAuthorOneMenthod"
          :roleId="currentRoleId"
        />
        <systermAuthorTwo
          ref="HemletSystermCompoment"
          v-show="selectSystemAuthorIndex === 1 && systermIsSelect"
          :roleId="currentRoleId"
          @systermAuthorChanged="systermAuthorChanged"
        />
        <applicationAuthorPC
          v-show="selectApplicationAuthorIndex === 1 && applicationIsSelect"
          @applicationAuthorPCMenthod="applicationAuthorPCMenthod"
          :roleId="currentRoleId"
        />
      </div>
    </div>
    <div class="flex_start_center">
      <el-button type="primary" @click="confiramSaveMenthod">保存</el-button>
      <el-button @click="cancleMenthod">取消</el-button>
    </div>
  </div>
</template>

<script>
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
import { saveDataAuthority, deleteDevice } from '../../../../api/deviceManage';
import systermAuthMenuTemplate from './componments/systermAuthMenuTemplate';
import applicationAuthMenuTemplate from './componments/applicationAuthMenuTemplate';
import systermAuthorOne from './componments/systermAuthorOne';
import systermAuthorTwo from './componments/systermAuthorTwo';
import systermAuthorFour from './componments/systermAuthorFour';
import applicationAuthorPC from './componments/applicationAuthorPC';
import applicationAuthorMobile from './componments/applicationAuthorMobile';
import applicationAuthorAlarmOne from './componments/applicationAuthorAlarmOne';
import applicationAuthorAlarmTwo from './componments/applicationAuthorAlarmTwo';

export default {
  data() {
    return {
      roleName: '', //角色名称
      roleDes: '', //角色描述
      currentRoleId: '', //如果是编辑页面，显示的roleid
      systermIsSelect: true, //系统权限管理
      applicationIsSelect: false, //应用权限管理
      selectSystemAuthorIndex: 0, //选中的系统管理权限的菜单索引
      selectApplicationAuthorIndex: 0, //选中的应用权限的菜单索引
      isAddRole: false, //判断是新增角色还是编辑角色
      systermAuthorOneData: '', //选中的系统管理菜单权限
      applicationAuthorPCData: '', //选中的应用菜单权限PC端
      applicationAuthorMobileData: '', //选中的应用菜单权限Mobile端
      applicationAuthorAlarmResorceData: '', //选中的业务数据权限-告警来源
      applicationAuthorAlarmTypeData: '', //选中的业务数据权限-告警类型
      dataBoxInfo: null,
      authorCanCreatGroup: false,
      authorCanAddDevice: false
    };
  },
  components: {
    systermAuthMenuTemplate, //系统管理权限菜单
    applicationAuthMenuTemplate, //应用权限菜单
    systermAuthorOne, //系统管理菜单权限
    systermAuthorTwo,
    systermAuthorFour,
    applicationAuthorPC,
    applicationAuthorMobile,
    applicationAuthorAlarmOne,
    applicationAuthorAlarmTwo
  },
  mounted() {
    if (this.$route.query.row) {
      this.isAddRole = false;
      this.currentRoleId = this.$route.query.row.roleId;
      this.roleName = this.$route.query.row.roleName;
      this.roleDes = this.$route.query.row.roleDesc;
    } else {
      this.isAddRole = true;
    }
  },
  methods: {
    dataBoxChanged(e) {
      this.dataBoxInfo = e;
    },
    leftClicked() {
      this.systermIsSelect = true;
      this.applicationIsSelect = false;
    },

    rightClicked() {
      this.systermIsSelect = false;
      this.applicationIsSelect = true;
    },

    //点击系统管理权限菜单
    systemAuthorMenthodClickedMenthod(e) {
      console.log(e);
      this.selectSystemAuthorIndex = e.index;
    },

    //点击应用权限菜单
    applicationAuthorMenuClickedMenthod(e) {
      console.log(e);
      this.selectApplicationAuthorIndex = e.index;
    },

    systermAuthorChanged(e) {
      this.authorCanCreatGroup = Number(e.canAddGroup);
      this.authorCanAddDevice = Number(e.canAddDevice);
    },

    /** 系统管理权限 - 系统管理菜单权限的回调 */
    systermAuthorOneMenthod(e) {
      this.systermAuthorOneData = e.value;
      console.log('---选中的PC后台菜单---' + JSON.stringify(e.value));
    },

    /** 应用权限 - PC端 */
    applicationAuthorPCMenthod(e) {
      this.applicationAuthorPCData = e.value;
      console.log('---选中的PC前台菜单---' + JSON.stringify(e.value));
    },

    /** 应用权限 - 手机端 */
    applicationAuthorMobileCMenthod(e) {
      this.applicationAuthorMobileData = e.value;
    },

    /** 业务数据权限 - 告警来源 */
    applicationAuthorAlarmOneMenthod(e) {
      this.applicationAuthorAlarmResorceData = e.value;
      console.log('---选中的告警来源---' + JSON.stringify(e.value));
    },

    /** 业务数据权限 - 告警类型 */
    applicationAuthorAlarmTwoMenthod(e) {
      this.applicationAuthorAlarmTypeData = e.value;
    },

    /** 确认保存按钮 */
    confiramSaveMenthod() {
      if (this.roleName.length <= 0) {
        this.$message.warning('请填写角色名称');
        return;
      }
      this.dealWihhRequestData();
    },

    /** 取消按钮 */
    cancleMenthod() {
      this.$router.back();
    },

    /** 处理要请求的数据 */
    dealWihhRequestData() {
      //角色实体类
      let role = {
        projectId: this.$cookies.get('PROJECT_ID'),
        roleName: this.roleName,
        roleDesc: this.roleDes,
        sysCode: 'SMHT',
        roleType: '1',
        systemId: '2',
        creator: this.$cookies.get('b-updateUser').realName
      };
      if (this.currentRoleId.length > 0) {
        role.roleId = this.currentRoleId;
      }
      //菜单列表
      let mechanslist = [];
      let pc_hdvm_menus = this.systermAuthorOneData;
      for (let index = 0; index < this.systermAuthorOneData.length; index++) {
        const element = this.systermAuthorOneData[index];
        let dict = {
          resId: element
        };
        if (this.currentRoleId.length > 0) {
          dict.roleId = this.currentRoleId;
        }
        mechanslist.push(dict);
      }

      for (let index = 0; index < this.applicationAuthorPCData.length; index++) {
        const element = this.applicationAuthorPCData[index];
        let dict = {
          resId: element
        };
        if (this.currentRoleId.length > 0) {
          dict.roleId = this.currentRoleId;
        }
        mechanslist.push(dict);
      }

      //监控点列表
      let mplist = [];
      for (let index = 0; index < this.applicationAuthorAlarmResorceData.length; index++) {
        const element = this.applicationAuthorAlarmResorceData[index];
        let dict = {
          MonitorPointId: element
        };
        if (this.currentRoleId.length > 0) {
          dict.roleId = this.currentRoleId;
        }
        mplist.push(dict);
      }

      //作业面列表
      let worklist = [];

      if (this.isAddRole) {
        //---------- 请求添加角色接口 ----------
        this.addRoleRequest(role, mechanslist, mplist, worklist);
      } else {
        //---------- 请求编辑角色接口 ----------
        this.editeRoleRequest(role, mechanslist, mplist, worklist);
      }
    },

    /** ======================================= ⬇ 网络请求相关 ⬇  ==============================================  */
    /** 子系统添加角色 */
    addRoleRequest(role, mechanslist, mplist, worklist) {
      Axios.requestJson({
        url: '/unicom/mngRole/systeminsert',
        data: {
          role,
          mechanslist,
          mplist,
          worklist
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            let roleId = res.data.result;
            this.saveDataAuthorityRequest(roleId);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },

    /** 子系统编辑角色 */
    editeRoleRequest(role, mechanslist, mplist, worklist) {
      Axios.requestJson({
        url: '/unicom/mngRole/systemupdate',
        data: {
          role,
          mechanslist,
          mplist,
          worklist
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            this.saveDataAuthorityRequest(this.currentRoleId);
          } else {
            this.$message.error(res.data.memo);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },

    async saveDataAuthorityRequest(roleId) {
      let paragram = {
        roleId: roleId,
        createGroup: this.authorCanCreatGroup,
        addGroup: this.authorCanAddDevice
      };
      let result = await saveDataAuthority(paragram);
      if (result.code == '1000') {
        if (this.currentRoleId.length > 0) {
          this.$message.success('角色编辑成功!');
          this.$router.back();
        } else {
          this.$message.success('添加成功!');
          this.$router.back();
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.contain_menu {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 35px;
  padding-right: 30px;
  padding-top: 29px;
  padding-bottom: 13px;
}

.flex_row_center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.image_1 {
  width: 18px;
  height: 18px;
  margin-left: 10px;
}

.font_16_000000_85 {
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
}

.font_14_000000_45 {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

.segment_contain {
  background: white;
  border-radius: 4px;
  height: 36px;
  width: 213px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.segment_left_contain {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  width: 120px;
  height: 36px;
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid #d9d9d9;
  cursor: pointer;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.segment_right_contain {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  width: 93px;
  height: 36px;
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid #d9d9d9;
  cursor: pointer;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.segment_select_color {
  color: #1890ff;
  border: 1px solid #1890ff;
}

.bottom_contain {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.09);
  margin-bottom: 14px;
  min-height: 400px;
}

.bottom_left_contain {
  width: 20%;
  height: 100%;
  padding-top: 12px;
}

.bottom_right_contain {
  width: 80%;
  /* height: 100%; */
  min-height: 100%;
  padding-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.09);
  padding-bottom: 50px;
}

.flex_start_center {
  display: flex;
  align-items: center;
}

/deep/ .el-select .el-input {
  width: 100px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}</style
>>
